import { getToken } from "../utils/authHelpers";
import { request } from "../utils/requestHelpers";

export default class CustomerRepository {
  CUSTOMERS_BASE = "/api/customers";

  constructor() {
    this.headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer"
    };
  }

  async getCustomersByNameOrId(instance, search) {
    const token = await getToken(instance);
    const path = `${this.CUSTOMERS_BASE}/search?customerNameOrId=${search}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers,
    });

    if (req.customers) {
      return Promise.resolve(req.customers);
    } else {
      return Promise.resolve([]);
    }
  }
}